const fr = {
  demo: {
    recorder_hint: "Lancez votre enregistrement d'écran maintenant…",
    starting_hint: "Démo guidée — démarrage dans 3 secondes",
    cancel: "Annuler",
    exit: "Quitter (Échap)",
    pause: "Pause (Espace)",
    resume: "Reprendre (Espace)",
    prev: "Scène précédente (←)",
    next: "Scène suivante (→)",
    tts_enable: "Activer la voix de synthèse",
    tts_disable: "Désactiver la voix de synthèse",
  },
  common: {
    save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier",
    create: "Créer", add: "Ajouter", search: "Rechercher", loading: "Chargement…",
    actions: "Actions", confirm: "Confirmer", close: "Fermer", back: "Retour",
    view: "Voir",
    yes: "Oui", no: "Non", all: "Tous", none: "Aucun", required: "requis",
    saved: "Enregistré", deleted: "Supprimé", created: "Créé", updated: "Mis à jour",
    download: "Télécharger", import: "Importer", export: "Exporter", upload: "Téléverser",
    new: "Nouveau", filter: "Filtrer", reset: "Réinitialiser",
    copied: "Copié",
  },
  nav: {
    dashboard: "Tableau de bord", companies: "Entreprises", contacts: "Contacts",
    principals: "Mandants",
    pipeline: "Pipeline", ai_agent: "Agent IA", reports: "Rapports", digest: "Digest",
    discover: "Découvrir",
    approvals: "Approbations",
    email_perf: "Email Perf.",
    ai_coach: "AI Coach",
    quality_audit: "Audit Qualité",
    market_intel: "Intel. Marché",
    api_credits: "Crédits API",
    private_docs: "Documents Privés",
    missions: "Missions Auto",
    data_prep: "Données (Admin)",
    countries: "Pays", sectors: "Secteurs", users: "Utilisateurs",
    settings: "Paramètres", import_export: "Import / Export", logout: "Déconnexion",
    light_mode: "Mode clair", dark_mode: "Mode sombre", reference: "Référentiel",
    administration: "Administration",
  },
  auth: {
    welcome_back: "Bon retour",
    login_hint: "Entrez vos identifiants pour accéder à votre espace.",
    email: "Email", password: "Mot de passe", name: "Nom",
    sign_in: "Se connecter", signing_in: "Connexion…",
    no_account: "Pas de compte ?", create_account: "Créer un compte",
    already_account: "Déjà inscrit ?", sign_up: "Créer mon compte",
    creating: "Création…",
    tagline_h1: "Le CRM de prospection<br />qui pense pour vous.",
    tagline_p: "Cartographiez vos marchés, identifiez les bons décideurs et générez des pitchs personnalisés. Un agent IA fait le travail de recherche à votre place.",
    multi_country: "Multi-pays", visual_pipeline: "Pipeline visuel", ai_agent: "Agent IA",
    live_status: "En ligne · 2026",
    hero_eyebrow: "IA · Pipelines doubles · Multi-pays",
    hero_eyebrow_v2: "Propulsé par Claude Sonnet 4.5",
    tagline_h1_v2: "Prospectez <hl>plus malin</hl>.<br />Closez <hl>plus vite</hl>.",
    bullet_1: "Un agent IA repère vos cibles et leurs décideurs en temps réel",
    bullet_2: "Pipelines doubles : Mandat (vos Mandants) + Ventes (vos prospects)",
    bullet_3: "Bilingue FR/EN · Multi-pays · Portail Mandant inclus",
    email_placeholder: "vous@entreprise.com",
    mock_pipeline: "Pipeline Ventes",
    mock_coach: "Boostez le taux d'ouverture de 18% — décalez les envois du mardi à 10h.",
    mock_apply: "Appliquer",
    mock_ignore: "Ignorer",
    mock_deal_won: "Deal gagné",
    feature_ai_title: "Agent IA de prospection",
    feature_ai_desc: "Claude Sonnet 4.5 identifie les bonnes entreprises et les bons décideurs à votre place.",
    feature_pipeline_title: "Pipelines doubles",
    feature_pipeline_desc: "Mandat (vos Mandants) + Ventes (vos prospects), au même endroit.",
    feature_country_title: "Multi-pays",
    feature_country_desc: "Suivez vos secteurs et prospects dans 30+ pays.",
    feature_portal_title: "Portail Mandant",
    feature_portal_desc: "Cockpit lien magique + rapports PDF mensuels pour vos Mandants.",
    stat_countries: "pays", stat_pipelines: "pipelines",
    stat_lang: "bilingue", stat_ai: "IA active",
    security_note: "Cookies JWT · Multi-locataire · RGPD",
    demo_credentials: "",
    split_eyebrow: "Plateforme de prospection augmentée par l'IA",
    split_headline_pre: "Transformez vos mandats",
    split_headline_em: "en deals signés.",
    split_sub: "Un agent IA qui cartographie vos marchés, qualifie les décideurs et rédige vos pitchs. Restez concentré sur ce qui compte : closer.",
    split_feat1: "Agent IA · Claude Sonnet 4.5",
    split_feat2: "Pipelines doubles · Mandat + Ventes",
    split_feat3: "Multi-tenant · Bilingue FR/EN",
    split_stat1_value: "+87%",
    split_stat1_label: "taux de qualification",
    split_stat2_value: "30+",
    split_stat2_label: "pays couverts",
    split_stat3_value: "24/7",
    split_stat3_label: "agent IA actif",
    footer_legal: "© 2026 Nexaforge",
    terms: "Conditions",
    privacy: "Confidentialité",
    status_operational: "Tous les systèmes opérationnels",
  },
  dashboard: {
    title: "Tableau de bord", subtitle: "Vue d'ensemble de votre activité commerciale",
    demo_data: "Données démo", new_company: "Nouvelle entreprise",
    test_guide: "Guide de test (PDF)",
    test_guide_downloaded: "Guide de test téléchargé",
    pitch_pdf: "Plaquette PDF",
    pitch_downloaded: "Plaquette téléchargée",
    demo_kit: "Kit Démo",
    demo_kit_label: "Documents commerciaux & production",
    pitch_hint: "Présentation client 8 pages (FR/EN auto)",
    video_kit: "Kit Vidéo (PDF)",
    video_kit_hint: "Script + storyboard + outils IA",
    video_kit_downloaded: "Kit vidéo téléchargé",
    auto_demo_script: "Script auto-démo (.py)",
    auto_demo_hint: "Playwright — l'app se joue toute seule",
    auto_demo_downloaded: "Script auto-démo téléchargé",
    guided_demo: "▶ Lancer la démo guidée",
    guided_demo_hint: "L'app navigue toute seule, dans cette fenêtre",
    demo_data_added: "Données démo ajoutées ({{companies}} entreprises, {{deals}} deals)",
    demo_data_already_present: "Les données démo sont déjà en place — rien à ajouter",
    hot_prospects: "Prospects chauds",
    see_all: "Tout voir",
    hot_empty_title: "Pas encore de prospects chauds",
    hot_empty_hint: "Une société devient HOT après une activité récente (< 7 j) ou un deal en proposition/négociation.",
    hot_reason_stage: "Deal en négociation",
    hot_reason_recent: "Activité il y a {{n}} j",
    hot_reason_new: "Nouveau signal",
    hot_leads: "Hot leads à relancer",
    hot_leads_empty_title: "Aucun lead chaud pour le moment",
    hot_leads_empty_hint: "Un contact devient chaud après des ouvertures, clics ou réponses sur vos emails.",
    hot_leads_empty_no_signed: "Marquez d'abord un Mandant comme « signed » dans Principals.",
    for: "pour",
    empty_title: "Démarrez avec des données démo",
    empty_subtitle: "5 pays, 6 secteurs, 8 entreprises et des deals pré-configurés.",
    load_demo: "Charger la démo",
    kpi_companies: "Entreprises", kpi_contacts: "Contacts", kpi_active_deals: "Deals actifs",
    kpi_pipeline_value: "{{value}} € pipeline", kpi_conversion: "Taux conversion",
    pipeline_evolution: "Évolution du pipeline (90 jours)",
    by_sector: "Par secteur", top_companies_ai: "Top entreprises (Score IA)",
    no_scored: "Aucune entreprise scorée. Utilisez « Enrichir avec IA » sur une fiche entreprise.",
    top_deals: "Top deals", no_deals: "Aucun deal pour l'instant",
    countries_title: "Pays", no_data: "Aucune donnée",
    data_health_title: "Qualité des données",
    data_health_breakdown: "{{verified}}% contacts vérifiés · {{dm}}% entreprises avec décideur",
    data_health_tier_excellent: "Excellent",
    data_health_tier_good: "Bon",
    data_health_tier_fair: "Moyen",
    data_health_tier_poor: "Faible",
  },
  coverage: {
    heat_map_title: "Heat Map de Couverture",
    target_per_cell: "Cible : {{n}} contacts / cellule",
    objectives_btn: "Objectifs",
    loading: "Chargement…",
    no_data: "Aucune donnée de couverture pour le moment.",
    no_data_hint: "Définissez vos objectifs par Mandant pour révéler les zones cibles.",
    set_objectives: "Définir mes objectifs",
    cell_hint: "Cliquez sur une cellule pour voir le détail et lancer une mission ciblée.",
    mandant: "Mandant",
    total: "Total",
    contacts: "Contacts",
    verified_emails: "Emails vérifiés",
    decision_makers: "Décideurs",
    drill_description: "Détail de la couverture pour cette combinaison Mandant × Pays.",
  },
  countries: {
    title: "Pays", subtitle: "Cartographie de vos marchés géographiques",
    new: "Nouveau pays", edit: "Modifier le pays", add: "Ajouter un pays",
    name: "Nom", code: "Code ISO", flag: "Drapeau (emoji)", currency: "Devise",
    col_country: "Pays", col_companies: "Entreprises", col_deals: "Deals actifs", col_pipeline: "Pipeline",
    empty: "Aucun pays. Ajoutez-en un.",
    confirm_delete: "Supprimer ce pays ?",
  },
  sectors: {
    title: "Secteurs", subtitle: "Catégorisez les industries de vos cibles (parents → sous-secteurs)",
    new: "Nouveau secteur", edit: "Modifier le secteur", add: "Ajouter un secteur",
    add_subsector: "Ajouter un sous-secteur",
    add_subsector_short: "Sous-secteur",
    parent_label: "Secteur parent",
    name: "Nom", description: "Description", icon: "Icône", color: "Couleur",
    name_required: "Le nom est requis",
    empty: "Aucun secteur. Ajoutez-en un.",
    confirm_delete: "Supprimer ce secteur ?",
    companies_attached: "Entreprises rattachées",
    subsectors: "sous-secteurs",
    no_subsectors: "Aucun sous-secteur. Cliquez sur « Sous-secteur » ou « Suggestion IA » pour en ajouter.",
    suggest_ai: "Suggestion IA",
    suggest_ai_hint: "Demander à l'IA des suggestions de sous-secteurs pertinents",
    suggest_title: "Suggestions IA pour « {{name}} »",
    suggesting: "L'IA réfléchit aux meilleurs sous-secteurs…",
    no_suggestions: "Aucune suggestion. Réessayez ou créez-en un manuellement.",
    no_suggestion_selected: "Sélectionnez au moins une suggestion.",
    add_selected: "Ajouter ({{n}})",
    subsectors_added: "{{count}} sous-secteurs ajoutés",
  },
  companies: {
    title: "Entreprises", subtitle_count: "{{count}} entreprise",
    subtitle_count_plural: "{{count}} entreprises",
    new: "Nouvelle entreprise", add: "Ajouter une entreprise",
    add_hint: "Renseignez le nom, le pays, le secteur et le rôle de l'entreprise.",
    name: "Nom", country: "Pays", sector: "Secteur", website: "Site web",
    linkedin: "LinkedIn URL", size: "Taille",
    search_placeholder: "Rechercher par nom…",
    filter_all_countries: "Tous les pays", filter_all_sectors: "Tous secteurs",
    filter_all_sizes: "Toutes tailles",
    col_company: "Entreprise", col_size: "Taille", col_score: "Score IA",
    col_contacts: "Contacts", col_deals: "Deals", col_status: "Statut",
    status_enriched: "Enrichi", status_in_progress: "En cours", status_pending: "À enrichir",
    none: "Aucune entreprise trouvée",
    tag_ai_discovered_hint: "Trouvée par la découverte IA",
    role_all: "Toutes",
    linked_principals: "Mandant(s) lié(s)",
    linked_principals_placeholder: "Sélectionner un ou plusieurs Mandants…",
    linked_principals_hint: "Ce Prospect est ciblé pour le compte de ces Mandants.",
    linked_principals_empty: "Aucun Mandant lié pour l'instant.",
  },
  role: {
    label: "Rôle",
    principal: "Mandant",
    prospect: "Prospect",
    other: "Autre",
    hint_principal: "Entreprise que vous représentez — vous vendez ses produits/services à des Prospects.",
    hint_prospect: "Client final potentiel — votre cible commerciale pour un ou plusieurs Mandants.",
    hint_other: "Partenaire, fournisseur, contact réseau, concurrent — hors modèle Mandant/Prospect.",
    principal_status: {
      prospecting: "À démarcher",
      in_discussion: "En discussion",
      proposal_sent: "Proposition envoyée",
      signed: "Signé",
      declined: "Refusé",
      paused: "En pause",
    },
  },
  principals: {
    title: "Mandants",
    subtitle_count: "{{count}} mandant",
    subtitle_count_plural: "{{count}} mandants",
    new: "Nouveau Mandant",
    add: "Ajouter un Mandant",
    status: "Statut du mandat",
    products_services: "Produits & services proposés",
    products_services_placeholder: "Ex : Logiciel CRM, Formation 5j…",
    products_services_hint: "Tapez puis Entrée pour ajouter chaque offre que vous commercialisez pour ce Mandant.",
    search_placeholder: "Rechercher un Mandant…",
    filter_all_status: "Tous les statuts",
    stats: {
      summary: "Synthèse",
      in_progress: "En cours (discussion + proposition)",
      total: "Total affiché",
      tenant_total: "au total",
      by_status: "Répartition par statut",
      by_sector: "Top secteurs",
    },
    linked_prospects: "Prospects rattachés",
    find_prospects_btn: "Trouver des prospects",
    analyze_dna_btn: "Analyser le site (ADN)",
    empty_title: "Aucun Mandant pour l'instant",
    empty_hint: "Un Mandant est une entreprise que vous représentez. Vous vendez ses produits/services à vos Prospects.",
    required_fields: "Nom, pays et secteur sont requis",
    created: "Mandant créé",
  },
  prospects: {
    title: "Trouver des prospects pour {{principal}}",
    target_markets: "Marchés cibles enregistrés",
    target_countries: "Pays cibles",
    target_sectors: "Secteurs cibles",
    search_in_country: "Rechercher dans le pays",
    in_sector: "Dans le secteur",
    any_sector: "Tous les secteurs",
    find: "Lancer la recherche",
    searching: "Recherche…",
    pick_country: "Choisissez un pays",
    existing_in_db_title: "Déjà en base ({{count}})",
    no_existing: "Aucune entreprise du même secteur dans ce pays n'est encore en base.",
    new_candidates_title: "Nouvelles pistes web ({{count}})",
    no_new_candidates: "Aucune nouvelle piste trouvée.",
    tavily_hint: "Configurez Tavily dans Paramètres pour activer la découverte web de nouvelles entreprises.",
    already_linked: "Lié",
    select_all: "Tout sélectionner",
    review_warning: "Vérifiez chaque candidat — Tavily peut renvoyer des articles ou répertoires qui ne sont pas de vraies entreprises. Cochez uniquement ceux qui correspondent à un site d'entreprise.",
    quality_medium: "À vérifier",
    quality_medium_hint: "URL non racine — vérifiez que c'est bien le site d'une entreprise.",
    confirm_llm_title: "Confirmer via Claude (recommandé)",
    confirm_llm_hint: "Une vérification IA en 1 phrase écarte les faux positifs résiduels.",
    llm_validated: "Validé IA {{confidence}}%",
    apply: "Lier / Importer ({{count}})",
    applying: "Application…",
    applied: "✅ {{linked}} entreprises liées · {{created}} nouvelles importées",
  },
  principal_360: {
    title: "Vue 360°",
    subtitle: "Cockpit Mandant",
    prospects_count: "Prospects ciblés",
    contacts: "contacts",
    dms: "décideurs",
    pipeline_value: "Pipeline ouvert",
    open_deals: "deals en cours",
    won_value: "Gagné (€)",
    won_deals: "gagnés",
    lost_deals: "perdus",
    emails_sent: "Emails envoyés",
    top_prospects: "Top 5 Prospects (par score IA)",
    no_prospects_yet: "Aucun Prospect rattaché à ce Mandant pour l'instant.",
    recent_activity: "Activité récente (30j)",
    no_activity: "Aucune activité récente.",
    commercializing: "Vous commercialisez pour ce Mandant",
    export_pdf: "Export PDF",
    pdf_ready: "Rapport PDF généré",
  },
  principal_digest: {
    title: "Digest mensuel Mandant",
    subtitle: "Envoie automatiquement le rapport PDF 360° à ce Mandant le 1er de chaque mois.",
    enabled_label: "Activer l'envoi automatique mensuel",
    viewer_email: "Email du Mandant",
    send_test: "Envoyer un test",
    hint: "Le PDF est envoyé en pièce jointe depuis votre domaine vérifié. Le 1er de chaque mois à 8h UTC.",
    sent_to: "Envoyé à",
    recent_sends: "Derniers envois",
    email_required: "Renseignez d'abord l'email du Mandant",
  },
  portal_invite: {
    title: "Portail Mandant (lecture seule)",
    button: "Inviter au portail",
    hint: "Envoie un lien magique 24h pour accéder au cockpit live + archives PDF.",
    lang_hint: "L'email d'invitation et les rapports seront envoyés dans la langue sélectionnée (FR/EN).",
    sent: "Invitation envoyée",
    last_login: "dernière connexion",
    never_connected: "jamais connecté",
  },
  portal: {
    brand: "Portail Mandant",
    loading: "Chargement…",
    welcome: "Connecté en tant que {{name}}",
    logout: "Déconnexion",
    nav: {
      cockpit: "Cockpit",
      prospects: "Prospects",
      activities: "Activités",
      digests: "Archives PDF",
    },
    login: {
      verifying: "Vérification de votre invitation…",
      success: "Accès accordé, redirection…",
      no_token: "Lien d'invitation invalide.",
      help: "Demandez à votre interlocuteur de renvoyer une nouvelle invitation.",
    },
    cockpit: {
      eyebrow: "COCKPIT EN TEMPS RÉEL",
      last_update: "Dernière mise à jour :",
      products: "Produits & services commercialisés pour vous",
      top_prospects: "Top prospects ciblés (par score IA)",
      no_prospects: "Aucun prospect rattaché pour l'instant.",
      recent_activity: "Activité récente (30j)",
      no_activity: "Aucune activité récente.",
      kpi: {
        prospects: "Prospects ciblés",
        contacts: "contacts",
        dms: "décideurs",
        pipeline: "Pipeline ouvert",
        open_deals: "deals en cours",
        won: "Gains confirmés (€)",
        emails: "Emails envoyés",
      },
    },
    prospects: {
      title: "Prospects ciblés pour vous",
      subtitle: "prospect(s) rattaché(s) à votre mandat",
      empty: "Aucun prospect rattaché pour l'instant. Votre agent commercial est sur le coup.",
    },
    activities: {
      title: "Timeline d'activité",
      subtitle: "30 derniers jours d'actions commerciales menées pour vous.",
      empty: "Aucune activité récente.",
    },
    digests: {
      title: "Archives des rapports mensuels",
      subtitle: "Vos rapports PDF mensuels envoyés.",
      empty: "Aucun rapport envoyé pour l'instant.",
      failed: "Échec d'envoi",
      download: "Télécharger",
    },
    pulse: {
      title: "Pouls hebdomadaire",
      last_7d: "· 7 derniers jours",
      active: "Agent actif",
      new_prospects: "Nouveaux prospects",
      deals_advanced: "Deals avancés",
      emails_sent: "Emails envoyés",
      activities: "Activités",
      reassure_active: "Votre agent commercial a été actif cette semaine sur votre mandat.",
      reassure_quiet: "Semaine calme. Votre agent commercial reprendra l'activité prochainement.",
    },
    notif: {
      title: "Notifications",
      empty: "Aucune notification pour le moment.",
      mark_all: "Tout marquer lu",
    },
  },
  ai_coach: {
    title: "AI Coach",
    analyze_now: "Analyser",
    last_run: "Dernière analyse",
    auto: "auto",
    manual: "manuel",
    empty: "Aucune recommandation active.",
    empty_hint: "Cliquez 'Analyser' pour générer des recommandations à partir de vos performances email.",
    sparse_msg: "Données insuffisantes ({{count}} emails, minimum {{min}}). Envoyez plus pour activer le coach.",
    run_done: "{{count}} recommandation(s) générée(s)",
    apply: "Appliquer",
    ignore: "Ignorer",
    applied: "Marquée comme appliquée",
    ignored: "Recommandation ignorée",
    confidence: "confiance",
  },
  ai_coach_history: {
    title: "AI Coach — Historique & impact",
    subtitle: "Suivez les recommandations passées et mesurez l'impact sur vos performances email.",
    refresh: "Actualiser",
    kpi: {
      total: "Total",
      total_hint: "90 derniers jours",
      applied: "Appliquées",
      ignored: "Ignorées",
      pending: "En attente",
    },
    impact: {
      title: "Évolution des performances email",
      subtitle: "12 dernières semaines",
      open: "Taux d'ouverture",
      click: "Taux de clic",
      reply: "Taux de réponse",
      empty: "Aucune donnée email sur la période.",
      empty_hint: "Envoyez des emails et les performances apparaîtront ici.",
      milestones: "Recos appliquées récentes",
    },
    list: {
      title: "Historique des recommandations",
      empty: "Aucune recommandation pour ce filtre.",
    },
    filters: {
      all: "Toutes",
      new: "En attente",
      applied: "Appliquées",
      ignored: "Ignorées",
      superseded: "Remplacées",
    },
    applied_on: "appliquée le",
    ignored_on: "ignorée le",
    reapply: "Réactiver",
    reapplied: "Recommandation réactivée",
  },
  company_detail: {
    overview: "Vue d'ensemble", contacts: "Contacts", offerings: "Produits & Services",
    competitors: "Concurrents", ai: "Analyse IA", deals: "Deals",
    activities: "Activités", synergy: "Synergie",
    description: "Description", information: "Informations",
    enrich_ai: "Enrichir avec IA", enriching: "Enrichissement…",
    find_decision_makers: "Trouver les décideurs", searching: "Recherche…",
    find_contacts_btn: "Trouver des contacts",
    find_contacts_mode: "Type de recherche",
    mode_dm: "Décideurs",
    mode_all: "Tous les contacts",
    validate_via_claude: "Valider via Claude",
    validate_via_claude_hint: "Écarte les noms/emails douteux retournés par Hunter.io.",
    run_search: "Lancer la recherche",
    competitor_ai: "Lancer analyse IA", analyzing: "Analyse…",
    generate_pitch: "Générer un pitch", generating: "Génération…",
    approach_angles: "Angles d'approche commerciale",
    pitches_generated: "Pitchs générés",
    no_description: "Aucune description. Lancez « Enrichir avec IA » pour générer une analyse complète.",
    pain_points: "Pain points", strengths: "Forces", weaknesses: "Faiblesses",
    opportunities: "Opportunités",
    add_note_placeholder: "Ajouter une note rapide…",
    confirm_delete_company: "Supprimer définitivement \"{{name}}\" et toutes ses données ?",
    no_activity: "Aucune activité",
    sources_label: "Sources web (Tavily)",
    no_reports: "Aucun rapport IA. Cliquez sur « Enrichir avec IA » pour démarrer.",
    no_competitors_ai: "Lancez l'analyse IA pour découvrir les concurrents et angles différenciateurs.",
    no_product: "Aucun produit détecté", no_service: "Aucun service détecté",
    no_contact: "Aucun contact",
    formal_email: "Email formel", linkedin_short: "LinkedIn court", punchy_email: "Email accroche",
    subject: "Sujet", copy: "Copier", copied: "Copié",
    decision_maker: "Décideur",
    dm_no_verified_title: "Aucun décideur vérifié trouvé",
    dm_no_verified_hint: "Nous n'inventons pas de contacts. Utilisez les liens LinkedIn ci-dessous pour rechercher manuellement les décideurs, puis ajoutez-les via 'Nouveau contact'.",
    dm_add_manually_hint: "Configurez Apollo.io ou Hunter.io dans Paramètres pour automatiser la recherche de décideurs vérifiés.",
    not_configured: "Non configuré",
  },
  company: {
    dm_added: "{{count}} décideurs ajoutés (source: {{source}})",
    dm_added_v2: "{{count}} contacts ajoutés ({{llm}} validés IA) · source: {{source}}",
    dm_no_verified: "Aucun décideur vérifié trouvé — recherche manuelle requise",
  },
  contacts: {
    title: "Contacts", count: "{{count}} contact",
    new: "Ajouter", add: "Ajouter un contact",
    first_name: "Prénom", last_name: "Nom", position: "Poste",
    email: "Email", phone: "Téléphone", seniority: "Séniorité",
    decision_maker: "Décideur", source: "Source",
    manual: "Manuel",
    unverified: "Non vérifié",
    search_placeholder: "Rechercher prénom, nom, email…",
    filter_all_seniorities: "Toutes séniorités", filter_decision_makers: "Décideurs uniquement",
    filter_all: "Tous",
    col_contact: "Contact", col_company: "Entreprise", col_position: "Poste",
    col_contact_info: "Coordonnées", col_seniority: "Séniorité", col_source: "Source",
    empty: "Aucun contact",
    verified: "Vérifié",
    send: "Envoyer", call: "Appeler", open: "Ouvrir", close: "Fermer",
    open_company: "Voir l'entreprise",
    save_notes: "Enregistrer les notes",
    notes: "Notes",
    notes_placeholder: "Notes internes sur ce contact…",
    tab_info: "Information",
    tab_engagement: "Engagement",
    emails_sent: "Envoyés",
    emails_opened_kpi: "Ouverts",
    emails_clicked_kpi: "Cliqués",
    emails_replied_kpi: "Réponses",
    emails_bounced_kpi: "Bounces",
    deals: "Deals",
    last_engagement: "Dernière activité",
    no_engagement: "Aucun historique d'engagement pour ce contact.",
    recent_emails: "Emails récents",
    linked_deals: "Deals liés",
    recent_activities: "Activités récentes",
    loading: "Chargement…",
    opened: "Ouvert",
    clicked: "Cliqué",
    replied: "Répondu",
    bounced: "Bounced",
    sort_recent: "Plus récents",
    sort_score: "Plus chauds",
    tier_hot: "Chaud",
    tier_warm: "Tiède",
    tier_tepid: "Frais",
    tier_cold: "Froid",
    score_explain: "Score d'engagement (fenêtre 90 jours)",
    opens: "Ouvertures",
    clicks: "Clics",
    replies: "Réponses",
    bounces: "Bounces",
    deals_30d: "Deals 30j",
    activities_30d: "Activités 30j",
    multinational_risk: "Domaine multinational – vérifier",
    entity_verified: "Entité vérifiée",
    verify_via_linkedin: "Vérifier via LinkedIn",
  },
  pipeline: {
    title: "Pipeline", subtitle: "Vue Kanban de vos opportunités de vente (Prospects)",
    subtitle_mandate: "Vue Kanban du parcours de signature de vos Mandants",
    tab_sales: "Pipeline Ventes",
    tab_mandate: "Pipeline Mandat",
    new_deal: "Nouveau deal", create_deal: "Créer un deal", pdf_ready: "PDF du pipeline généré",
    deal_title: "Titre", company: "Entreprise", value: "Valeur",
    currency: "Devise", stage: "Stage", close_date: "Date close estimée",
    notes: "Notes",
    stat_active: "Deals actifs", stat_value: "Valeur pipeline",
    stat_won: "Gagnés", stat_conversion: "Conversion",
    stages: {
      LEAD: "Lead", QUALIFIED: "Qualifié", CONTACTED: "Contacté",
      MEETING_SCHEDULED: "Meeting", PROPOSAL_SENT: "Proposition",
      NEGOTIATION: "Négociation", WON: "Gagné", LOST: "Perdu",
      IDENTIFIED: "Identifié", IN_DISCUSSION: "En discussion",
      SIGNED: "Signé", DECLINED: "Refusé",
    },
  },
  ai_agent: {
    title: "Agent IA Prospection",
    subtitle: "Claude Sonnet 4.5 · fallback GPT-5.2",
    new_conv: "Nouvelle conversation", history: "Historique",
    no_conv: "Aucune conversation",
    welcome: "Que recherchez-vous aujourd'hui ?",
    welcome_sub: "Demandez à l'agent de trouver des entreprises, qualifier des prospects, ou suggérer des décideurs.",
    placeholder: "Écrivez votre demande… (Enter pour envoyer, Shift+Enter pour nouvelle ligne)",
    thinking: "L'agent réfléchit…",
    confirm_delete_session: "Supprimer cette conversation ?",
  },
  reports: {
    title: "Rapports IA", subtitle: "Toutes les analyses générées par l'agent",
    empty: "Aucun rapport. Enrichissez une entreprise pour générer une analyse IA.",
  },
  settings: {
    title: "Paramètres", subtitle: "Configurez votre profil et l'agent IA",
    profile: "Profil",
    activity_section: "Votre activité (utilisé par l'agent IA)",
    activity_label: "Description de votre activité",
    activity_hint: "L'IA utilise ce texte pour générer des pitchs personnalisés et contextualiser ses réponses.",
    services_label: "Services que vous proposez",
    add_service: "Ajouter un service…",
    preferences: "Préférences",
    default_currency: "Devise par défaut", ai_language: "Langue de l'IA",
    integrations: "Intégrations externes",
    integrations_hint: "Saisissez vos clés API pour activer l'enrichissement en données réelles. Les clés sont stockées chiffrées et masquées à l'affichage.",
    apollo_key: "Clé Apollo.io", hunter_key: "Clé Hunter.io",
    tavily_key: "Clé Tavily", key_placeholder: "Coller votre clé…",
    where_to_get: "Où l'obtenir ?",
    save_settings: "Enregistrer",
  },
  users: {
    title: "Utilisateurs", subtitle: "Gérer les comptes et leurs droits d'accès",
    new: "Nouveau compte", create: "Créer un utilisateur", edit: "Modifier l'utilisateur",
    email: "Email", password: "Mot de passe", name: "Nom", role: "Rôle",
    role_admin: "Admin (tout accès + gestion)",
    role_user: "Utilisateur (édition, scope limité)",
    role_viewer: "Viewer (lecture seule, scope limité)",
    access_all: "Accès complet à toutes les données",
    access_scope: "Limiter l'accès",
    access_countries: "Pays accessibles",
    access_sectors: "Secteurs accessibles",
    access_companies: "Entreprises spécifiques",
    is_active: "Compte actif",
    col_user: "Utilisateur", col_role: "Rôle", col_access: "Périmètre",
    col_status: "Statut", col_created: "Créé le", col_digest: "Digest",
    digest_enabled: "Digest hebdomadaire (email)",
    digest_hint: "L'utilisateur recevra le récap de la semaine chaque lundi matin.",
    digest_enabled_toast: "Digest activé pour {{email}}",
    digest_disabled_toast: "Digest désactivé pour {{email}}",
    digest_test_sent: "Email test envoyé à {{email}}",
    digest_send_test: "Envoyer un email test",
    confirm_delete: "Supprimer ce compte ?",
    cannot_delete_self: "Vous ne pouvez pas supprimer votre propre compte",
  },
  import_export: {
    title: "Import / Export",
    subtitle: "Charger des données en masse depuis un fichier CSV ou exporter votre base.",
    templates: "Modèles de fichiers",
    templates_hint: "Téléchargez un modèle pré-rempli, complétez vos données, puis importez le fichier.",
    template_companies: "Modèle Entreprises (CSV)",
    template_contacts: "Modèle Contacts (CSV)",
    download_template: "Télécharger le modèle",
    import: "Importer un fichier",
    import_companies: "Importer des entreprises",
    import_contacts: "Importer des contacts",
    choose_file: "Choisir un fichier CSV",
    drop_or_click: "Glissez votre fichier ici ou cliquez pour parcourir",
    importing: "Import en cours…",
    export: "Exporter la base",
    export_companies: "Exporter toutes les entreprises",
    export_contacts: "Exporter tous les contacts",
    export_deals: "Exporter tous les deals",
    export_activities: "Exporter toutes les activités",
    export_filters: "Filtres avancés",
    export_filters_hint: "Filtrez vos exports CSV par date, pays, secteur, stage et plus.",
    filter_date_from: "Date début (créé après)",
    filter_date_to: "Date fin (créé avant)",
    filter_close_from: "Close estimée — début",
    filter_close_to: "Close estimée — fin",
    filter_countries: "Pays",
    filter_sectors: "Secteurs",
    filter_stages: "Stages",
    filter_sizes: "Tailles d'entreprise",
    filter_seniorities: "Séniorités",
    filter_owners: "Propriétaires",
    filter_activity_types: "Types d'activité",
    filter_ai_score_min: "Score IA min",
    filter_ai_score_max: "Score IA max",
    filter_value_min: "Valeur min (€)",
    filter_value_max: "Valeur max (€)",
    filter_dm_only: "Décideurs uniquement",
    filter_tag: "Tag (un seul)",
    filter_select_placeholder: "—",
    filter_multi_placeholder: "Sélectionner…",
    filter_reset: "Réinitialiser",
    filter_export_now: "Exporter",
    no_filters: "Aucun filtre — tout sera exporté.",
    active_filters: "{{count}} filtre actif",
    active_filters_plural: "{{count}} filtres actifs",
    result_title: "Résultat de l'import",
    result_created: "{{n}} créés", result_updated: "{{n}} mis à jour",
    result_skipped: "{{n}} ignorés",
    errors_title: "Lignes ignorées",
    error_line: "Ligne {{line}}",
    notes_title: "Comment ça marche ?",
    notes: [
      "Les entreprises doivent référencer un pays existant via country_code (ex: FR, MA).",
      "Si le secteur n'existe pas, il sera créé automatiquement.",
      "Pour les contacts, company_name doit correspondre à une entreprise existante.",
      "L'import est idempotent : un doublon (même nom) sera mis à jour, pas dupliqué.",
    ],
  },
  synergy: {
    title: "Synergie", legend: "Cartographie globale de l'entreprise",
    timeline: "Fil d'activité", radial: "Vue radiale", related: "Entreprises liées",
    no_timeline: "Aucun événement enregistré pour cette entreprise.",
    no_related: "Aucune entreprise liée (même secteur ou pays).",
    same_sector: "Même secteur", same_country: "Même pays",
    decision_makers: "Décideurs", active_pipeline: "Pipeline actif",
    products: "Produits", services: "Services",
    competitors: "Concurrents", reports: "Rapports IA",
    click_hint: "Cliquez sur un nœud pour voir les détails",
    details_for: "Pour {{name}}",
    empty_list: "Aucun élément à afficher.",
    decision_maker: "Décideur",
    // Explorer mode (cross-companies)
    explorer_mode: "Explorer",
    scope_this: "Cette entreprise",
    scope_same_sector: "Même secteur",
    scope_same_country: "Même pays",
    scope_same_sector_and_country: "Secteur + Pays",
    explorer_for: "Pour {{name}} · périmètre : {{scope}}",
    peers_count_one: "{{count}} entreprise pair",
    peers_count_other: "{{count}} entreprises pairs",
    peers_count: "{{count}} pairs",
    empty_explorer: "Aucun résultat dans le périmètre « {{scope}} ».",
    decision_makers_only: "Décideurs uniquement",
    via: "via",
  },
  timeline: {
    company_created: "Entreprise ajoutée à la base",
    deal_created: "Deal créé : {{deal}}",
    deal_updated: "Deal mis à jour : {{deal}}",
  },
  errors: {
    network: "Erreur réseau", forbidden: "Action non autorisée",
    not_found: "Élément introuvable", validation: "Données invalides",
  },
  digest: {
    title: "Digest hebdomadaire",
    subtitle: "Récap automatique de vos signaux IA, deals avancés et décideurs détectés sur la semaine.",
    preview_email: "Aperçu email",
    preview_label: "Aperçu HTML",
    send_test_to_me: "M'envoyer un test",
    run_now: "Envoyer maintenant à tous",
    not_configured: "Resend n'est pas configuré. Ajoutez RESEND_API_KEY dans le backend pour activer l'envoi.",
    schedule: "Programmation",
    schedule_hint: "Le digest est envoyé automatiquement à cette heure chaque semaine.",
    my_status: "Mon abonnement",
    enabled: "Activé",
    disabled: "Désactivé",
    ask_admin: "Demandez à l'admin pour activer",
    self_disabled: "Votre digest est désactivé. Seul l'admin peut le réactiver.",
    history_count: "Digests envoyés",
    last_sends: "Lignes en base",
    current_week: "Aperçu de cette semaine",
    kpi_pipeline: "Pipeline", kpi_active: "Deals actifs",
    kpi_wins: "Gagnés (7j)", kpi_new: "Nouveaux deals",
    hot_signals: "🔥 Signaux chauds IA",
    advanced_deals: "📈 Deals avancés",
    new_dms: "👤 Nouveaux décideurs",
    stagnant: "⏰ Deals stagnants (>14j)",
    no_hot: "Aucun signal chaud cette semaine.",
    no_movement: "Aucun mouvement de deal.",
    no_dms: "Aucun nouveau décideur.",
    no_stagnant: "Tous vos deals sont frais.",
    history: "Historique",
    empty_history: "Aucun digest envoyé pour l'instant. Cliquez sur « M'envoyer un test ».",
    col_sent_at: "Envoyé le", col_user: "Utilisateur",
    col_subject: "Sujet", col_status: "Statut",
    sent: "Envoyé", failed: "Échec",
    test_sent: "Email envoyé à {{email}}",
    run_done: "{{sent}}/{{total}} digests envoyés",
    day_mon: "Lundi", day_tue: "Mardi", day_wed: "Mercredi",
    day_thu: "Jeudi", day_fri: "Vendredi", day_sat: "Samedi", day_sun: "Dimanche",
  },
  discover: {
    title: "Découvrir des entreprises",
    subtitle: "L'agent IA cherche le web et propose une liste de prospects pertinents que vous pouvez ajouter en un clic.",
    ai_approved_banner: "Chaque candidat est extrait du web (Tavily) puis curé par Claude (Anthropic). Le score de fit (0-100) reflète la pertinence évaluée par l'IA selon vos services + critères. Les candidats ≥ 70 sont marqués « Validé IA ».",
    ai_approved: "Validé IA",
    form_title: "Critères de recherche",
    field_countries: "Pays cibles",
    field_sectors: "Secteurs cibles",
    field_services: "Mes services proposés",
    services_hint: "Pré-rempli depuis vos paramètres. Modifiez pour cette recherche uniquement.",
    field_criteria: "Critères additionnels (optionnel)",
    field_limit: "Nombre d'entreprises",
    placeholder_countries: "Tous les pays",
    placeholder_sectors: "Tous les secteurs",
    placeholder_services: "Ex: Logiciel SaaS de gestion de la relation client pour PME",
    placeholder_criteria: "Ex: startups Series A/B, PME 50-200 employés, e-commerce growth stage…",
    companies: "entreprises",
    need_tavily: "L'API Tavily n'est pas configurée. Ajoutez votre clé dans Paramètres → API Keys pour utiliser la découverte.",
    need_filter: "Renseignez au moins un pays, un secteur ou des critères additionnels.",
    run: "Lancer la découverte",
    searching: "Recherche en cours…",
    found: "{{n}} prospects identifiés",
    saved: "{{created}} ajoutés · {{skipped}} déjà existants",
    sources_used: "Sources web utilisées par l'IA",
    selected_count: "{{count}}/{{total}} sélectionnés",
    select_all: "Tout sélectionner",
    deselect_all: "Tout désélectionner",
    rerun: "Relancer",
    add_selected: "Ajouter {{count}} entreprise",
    add_selected_plural: "Ajouter {{count}} entreprises",
    assign_country: "Pays",
    assign_sector: "Secteur",
    unassigned: "Non assigné",
    no_candidates: "Aucun prospect identifié. Affinez vos critères.",
  },
  notifications: {
    title: "Notifications",
    empty: "Aucune notification.",
    mark_all_read: "Tout marquer comme lu",
    view_all: "Voir tout",
    just_now: "à l'instant",
    minutes_ago: "il y a {{n}} min",
    hours_ago: "il y a {{n}} h",
    days_ago: "il y a {{n}} j",
    prefs_title: "Préférences de notification",
    prefs_hint: "Choisissez ce que vous voulez recevoir et comment.",
    event_hot_ai_signal: "Signal IA chaud sur une entreprise suivie",
    event_deal_stage_change: "Changement de stage d'un deal",
    event_new_decision_maker: "Nouveau décideur ajouté",
    event_stagnant_deal: "Deal stagnant (>14 jours)",
    col_in_app: "In-app",
    col_email: "Email",
    email_not_configured: "Resend n'est pas configuré — les emails ne seront pas envoyés.",
  },
  watch: {
    title: "Veille automatique",
    subtitle: "Surveillance quotidienne par IA des nouveautés sur vos entreprises prioritaires.",
    last_run: "Dernière exécution",
    never: "Jamais",
    schedule: "Programmation : tous les jours à {{hour}}:00 UTC",
    run_now: "Lancer maintenant pour moi",
    no_signals: "Aucun signal détecté pour le moment.",
    signals_count: "{{n}} signaux récents",
    hot_only: "Signaux chauds uniquement",
    detected_at: "Détecté le",
    open_company: "Voir l'entreprise",
  },
  temperature: {
    HOT: "Chaud", WARM: "Tiède", COLD: "Froid",
    hot_short: "🔥", warm_short: "☀️", cold_short: "❄️",
    title: "Température",
    filter_all: "Toutes",
    filter_hot: "🔥 Chauds", filter_warm: "☀️ Tièdes", filter_cold: "❄️ Froids",
  },
  pdf: {
    export_one: "Exporter en PDF",
    export_bulk: "Exporter tous les rapports",
    generating: "Génération du PDF…",
  },
  autopilot: {
    title: "Pipeline Autopilot",
    subtitle: "Laissez l'IA découvrir, enrichir et qualifier des prospects automatiquement chaque jour.",
    active: "Actif",
    enable: "Activer Autopilot",
    enable_hint: "Tourne tous les jours à {{hour}}:00 UTC en background. Vous recevez une notification dès que de nouveaux prospects sont prêts.",
    mode: "Mode de prospection",
    mode_find_customers: "Trouver des Clients",
    mode_find_customers_hint: "Cherche des Prospects pour chaque Mandant (utilise leurs produits/services comme pitch)",
    mode_find_principals: "Trouver des Mandants",
    mode_find_principals_hint: "Cherche des entreprises que vous pourriez représenter comme agent",
    mode_both: "Les deux",
    mode_both_hint: "Mandants + Clients à chaque run",
    countries: "Pays cibles",
    sectors: "Secteurs cibles",
    any: "Tous",
    criteria: "Critères additionnels",
    criteria_placeholder: "Ex: Series A/B, 50-200 employés, SaaS B2B…",
    min_score: "Score IA minimum",
    max_per_run: "Max par run",
    actions_per_run: "Actions à enchaîner",
    auto_enrich: "Enrichir automatiquement (analyse IA + sources)",
    auto_find_dms: "Chercher les décideurs (Apollo + IA fallback)",
    last_runs: "Dernières exécutions",
    created_label: "ajoutés",
    enriched_label: "enrichis",
    run_now: "Tester maintenant",
    saved: "Configuration enregistrée",
    skipped: "Skipped : {{reason}}",
    error: "Erreur",
    run_done: "{{created}} prospects ajoutés, {{enriched}} enrichis",
    running_bg: "Autopilot lancé en arrière-plan. Résultat dans ~30s.",
  },
  email: {
    compose_title: "Rédiger un email IA",
    no_contact_selected: "Aucun contact sélectionné",
    no_recipient: "Pas d'email pour ce contact",
    tone: "Ton",
    tone_formal: "Formel",
    tone_casual: "Décontracté",
    tone_urgent: "Direct & urgent",
    include_signals: "Inclure les signaux web récents",
    include_signals_hint: "Utilise les dernières actualités Tavily (levée, embauche, IPO…) pour personnaliser.",
    custom_brief: "Brief additionnel (optionnel)",
    custom_brief_placeholder: "Ex: mentionne notre récente étude de cas dans le retail",
    generate: "Générer le brouillon",
    regenerate: "Régénérer",
    generating: "Génération en cours…",
    draft_ready: "Brouillon prêt — relisez avant d'envoyer",
    subject: "Sujet",
    body: "Corps de l'email",
    preview: "Aperçu",
    edit: "Éditer",
    send: "Envoyer",
    sending: "Envoi…",
    sent_to: "Email envoyé à {{email}}",
    signals_used: "Signaux web utilisés",
    history_title: "Emails envoyés",
    validating: "Vérification…",
    validation_valid: "Email valide",
    validation_risky: "À risque",
    validation_invalid: "Email invalide",
    validation_unknown: "Non vérifié",
    blocked_title: "Envoi bloqué — adresse invalide",
    blocked_hint: "Cette adresse a échoué à la vérification automatique. Corrigez l'email du contact ou désactivez la vérification dans Paramètres.",
    blocked_invalid: "Envoi bloqué — adresse invalide ({{flags}})",
    followup_label: "Programmer une relance automatique",
    followup_hint: "L'IA rédigera la relance puis vous la présentera pour approbation (zéro envoi automatique).",
    followup_days_unit: "jour(s)",
    fu_scheduled: "Relance planifiée",
    fu_sent: "Relance envoyée",
    fu_drafted_pending: "Brouillon à approuver",
    fu_cancelled: "Relance annulée",
    fu_skipped_opened: "Email ouvert — relance annulée",
    fu_skipped_bounced: "Bounce — relance annulée",
    fu_skipped: "Relance annulée",
    fu_error: "Erreur relance",
    fu_due_at: "prévu le {{date}}",
    fu_send_now: "Envoyer",
    fu_cancelled_ok: "Relance annulée",
    fu_sent_ok: "Relance envoyée",
  },
  approvals: {
    title: "Approbations email",
    subtitle: "Relisez et approuvez chaque relance générée par l'IA avant son envoi.",
    queue: "File d'attente",
    empty_title: "Aucune relance en attente",
    empty_hint: "Quand l'IA prépare une relance, elle apparaît ici pour que vous l'approuviez avant envoi.",
    select_hint: "Sélectionnez une relance dans la liste pour la relire.",
    approve_send: "Approuver et envoyer",
    reject: "Rejeter",
    save_edit: "Enregistrer",
    edit_saved: "Modifications enregistrées",
    approved_ok: "Email envoyé",
    rejected_ok: "Relance rejetée",
    confirm_reject: "Rejeter définitivement cette relance ?",
    confirm_approve: "Envoyer cet email à {{email}} maintenant ?",
    expires_on: "Expire le {{date}}",
  },
  email_perf: {
    title: "Performance Email",
    subtitle: "Suivez l'engagement de vos campagnes : ouvertures, clics, meilleures heures, sujets gagnants.",
    sent: "Envoyés",
    delivered: "Délivrés",
    delivered_n: "délivrés",
    open_rate: "Taux d'ouverture",
    click_rate: "Taux de clic",
    bounce_rate: "Taux de bounce",
    opens: "ouvertures",
    clicks: "clics",
    bounces: "bounces",
    over_days: "sur {{d}} jours",
    timeline: "Évolution",
    heatmap: "Meilleures heures d'envoi (taux d'ouverture)",
    heatmap_hint: "Plus la couleur est intense, meilleur est le taux d'ouverture sur ce créneau.",
    top_subjects: "Top sujets (ouverture)",
    top_companies: "Entreprises les plus engagées",
    reply_rate_soon_title: "Taux de réponse — bientôt disponible",
    reply_rate_soon_hint: "Nécessite l'intégration Gmail/Outlook pour détecter automatiquement les réponses entrantes.",
    coming_soon: "Bientôt",
  },
  validation: {
    title: "Vérification des emails",
    description: "Pipeline anti-bounce : format → MX DNS (gratuit, illimité) → NeverBounce (premium, pour les cas douteux).",
    active: "Actif",
    not_configured: "Non configuré",
    low_balance: "Crédits faibles",
    free_credits: "Free",
    paid_credits: "Payés",
    total_credits: "Total",
    pipeline_hint: "Les emails déjà invalides au niveau format/MX ne consomment AUCUN crédit NeverBounce.",
    skip_label: "Désactiver la vérification avant envoi",
    skip_hint: "À cocher uniquement si vous êtes 100% sûr de la qualité de vos listes. Risque accru de ban Resend.",
  },
  dataprep: {
    title: "Préparation des données",
    subtitle: "Sauvegardez vos données puis videz la base de démonstration avant la Phase 2.",
    step1_title: "Étape 1 — Sauvegarder vos données actuelles",
    step1_hint: "Téléchargez un ZIP contenant un CSV par collection (companies, contacts, deals, emails, etc.). À conserver précieusement.",
    business_data: "Données métier (seront effacées)",
    kept_data: "Données conservées",
    kept_hint: "Vos utilisateurs, mots de passe, secteurs et pays de référence restent intacts.",
    download_zip: "Télécharger l'archive ZIP complète",
    exporting: "Génération de l'archive…",
    export_ok: "Archive téléchargée — conservez-la précieusement",
    export_ok_suffix: "téléchargé",
    export_fail: "Échec de l'export",
    step2_title: "Étape 2 — Vider les données métier (irréversible)",
    step2_hint: "Cette action supprime toutes les entreprises, contacts, deals, emails envoyés, signaux et notifications. Vos comptes utilisateurs et les secteurs/pays sont préservés.",
    start_wipe: "Commencer la procédure de vidage",
    confirm_title: "⚠ Action irréversible",
    confirm_bullet1: "Toutes les entreprises et leurs contacts seront supprimés",
    confirm_bullet2: "L'historique d'emails, notifications et signaux IA seront effacés",
    confirm_bullet3: "Vos comptes utilisateurs, secteurs et pays restent intacts",
    type_to_confirm: "Pour confirmer, tapez exactement : {{token}}",
    confirm_wipe: "Confirmer le vidage",
    wiping: "Suppression en cours…",
    wipe_ok: "Données supprimées ({{n}} documents) — vous pouvez maintenant repartir clean",
    popup_blocked: "Pop-up bloqué — autorisez les pop-ups pour ce site puis réessayez.",
    popup_hint: "Le téléchargement se lance dans cet onglet… ne le fermez pas.",
    export_triggered: "Téléchargement lancé dans un nouvel onglet — vérifiez votre dossier Téléchargements.",
    token_not_ready: "Préparation du lien sécurisé en cours… réessayez dans 2 secondes.",
    token_loading: "Préparation du lien sécurisé…",
    fallback_title: "Téléchargement du ZIP de sauvegarde",
    fallback_hint: "L'éditeur Emergent bloque les téléchargements directs depuis l'iframe. Copiez l'URL ci-dessous et collez-la dans un nouvel onglet Chrome :",
    fallback_step1: "Cliquez sur \"Copier\" ci-dessous",
    fallback_step2: "Ouvrez un nouvel onglet Chrome (Ctrl+T) — pas un onglet dans l'éditeur",
    fallback_step3: "Collez l'URL (Ctrl+V) puis Entrée — le ZIP se télécharge",
    token_expires_hint: "Le lien expire dans 5 minutes — il se renouvelle automatiquement toutes les 4 min.",
    copy: "Copier",
    url_copied: "URL copiée — collez-la dans un nouvel onglet Chrome",
  },
  resend_domain: {
    title: "Domaine d'envoi (Resend)",
    subtitle: "Vérifiez votre domaine pour envoyer le digest à n'importe quelle adresse (par défaut, seul votre email vérifié reçoit les tests).",
    current_sender: "Adresse expéditeur actuelle",
    test_mode: "Mode test",
    test_mode_hint: "En mode test, seules les adresses vérifiées sur votre compte Resend reçoivent les emails. Vérifiez un domaine pour envoyer à tous.",
    add_domain: "Ajouter un domaine",
    add: "Ajouter",
    added: "Domaine ajouté — configurez les records DNS ci-dessous",
    existed: "Domaine déjà présent sur Resend",
    your_domains: "Vos domaines",
    check: "Vérifier",
    verify_triggered: "Vérification déclenchée",
    dns_records_title: "Records DNS à ajouter chez votre registrar",
    dns_hint: "Copiez ces 3 enregistrements chez Cloudflare/OVH/Namecheap, puis cliquez « Vérifier ».",
    use_as_sender: "Définir comme expéditeur",
    sender_set: "Expéditeur défini : {{email}}",
    open_dashboard: "Ouvrir le dashboard Resend",
  },
  mandant_dna: {
    title: "ADN du Mandant — {{name}}",
    intro: "L'IA va lire profondément le site web du Mandant et comprendre son métier réel : produits/services, secteurs cibles, profils acheteurs, concurrents.",
    intro_step1: "Découverte automatique de jusqu'à 10 pages clés (homepage, produits, solutions, références)",
    intro_step2: "Extraction du contenu via Tavily et analyse par Claude (Anthropic)",
    intro_step3: "Profil structuré que vous validez avant de l'appliquer au Mandant",
    website_label: "Site analysé",
    no_website: "(aucun site renseigné)",
    warn_no_website: "Ajoutez d'abord un site web au Mandant.",
    analyze_btn: "Lancer l'analyse",
    analyzing_title: "Analyse en cours…",
    analyzing_hint: "Crawl + IA — environ 60 secondes pour un site complet.",
    meta_pages: "{{count}}/{{total}} pages lues",
    section_pitch: "Pitch synthétique",
    section_products: "Produits & services",
    section_industries: "Industries acheteuses",
    section_sectors: "Secteurs proposés pour le CRM",
    section_buyers: "Profil acheteur",
    section_competitors: "Concurrents identifiés",
    section_keywords: "Mots-clés de prospection",
    section_redflags: "Limites à connaître",
    buyer_size: "Taille d'entreprise",
    buyer_geo: "Force géographique",
    buyer_roles: "Rôles décisionnels",
    buyer_use_cases: "Cas d'usage typiques",
    cancel: "Annuler",
    rerun: "Relancer",
    apply: "Appliquer au Mandant",
    applied: "Profil appliqué ({{fields}} champs, {{sectors}} secteurs liés)",
    subsectors_created: "{{count}} nouveau(x) sous-secteur(s) créé(s)",
    error_extract: "Impossible d'extraire le contenu : {{error}}",
  },
  market_intel: {
    title: "Intelligence Marché",
    subtitle: "Brief stratégique par pays : projets, acheteurs, concurrents, gaps de couverture pour acquérir de nouveaux Mandants.",
    country: "Pays cible", pick_country: "Choisir un pays…",
    sector_hint: "Secteur (optionnel)", sector_placeholder: "Ex: Water & Desalination",
    generate: "Générer le brief", refresh: "Rafraîchir",
    analyzing: "Analyse en cours…",
    analyzing_hint: "6 recherches web + synthèse IA — environ 90 secondes",
    from_cache: "Brief récent récupéré du cache (< 7 jours)",
    generated: "Brief généré ✓",
    cached_label: "depuis cache",
    section_macro: "Vue macro",
    section_sectors: "Secteurs en croissance",
    section_projects: "Mega-projets",
    section_buyers: "Top acheteurs B2B",
    section_competitors: "Concurrents actifs dans le pays",
    section_gaps: "Gaps de couverture (opportunités de Mandants)",
    section_tenders: "Tenders à venir",
    gap_ideal: "Profil de Mandant idéal",
    gap_pitch: "Angle de pitch",
    generate_pitch_pdf: "Générer le pitch deck",
  },
  pitch_deck: {
    title: "Générer un pitch deck",
    candidate_name: "Nom du Mandant candidat",
    candidate_placeholder: "Ex: Wabag",
    candidate_url: "Site web (optionnel)",
    start: "Générer",
    running: "Génération…",
    generating: "Claude rédige les 4 slides… ~90s",
    download_pdf: "Télécharger le PDF",
  },
  quality: {
    title: "Audit Qualité",
    subtitle: "Identifiez les contacts non vérifiés et les entreprises sans décideur. Lancez une vérification en masse via Hunter.io.",
    kpi_contacts_verified: "Contacts vérifiés",
    kpi_contacts_unverified: "Non vérifiés",
    kpi_contacts_no_email: "Sans email",
    kpi_companies_no_dm: "Sans décideur",
    section_companies_no_dm: "Entreprises sans décideur",
    actionable_count: "{{actionable}} actionnables sur {{total}} (avec site web)",
    selected: "{{count}} sélectionnée(s)",
    bulk_verify_via_hunter: "Vérifier via Hunter",
    bulk_max: "Maximum 50 entreprises par lot.",
    bulk_done: "Audit terminé : {{contacts}} nouveaux contacts ajoutés sur {{companies}} entreprises.",
    all_companies_have_dm: "Toutes les entreprises ont au moins un décideur. 🎉",
    all_contacts_verified: "Tous les contacts sont vérifiés. 🎉",
    section_unverified_contacts: "Contacts non vérifiés",
    no_dm: "Aucun décideur",
    no_website: "Pas de site",
    col_website: "Site web",
    col_status: "Statut",
    run_hunter: "Rechercher les décideurs via Hunter.io",
    no_website_for_hunter: "Ajoutez un site web à l'entreprise pour lancer Hunter.io.",
    hunter_found: "{{count}} décideur(s) trouvés via {{provider}} ✓",
    hunter_pattern_only: "Aucun décideur trouvé, mais pattern email détecté : {{pattern}}",
    hunter_none: "Aucun décideur trouvé via Hunter.io. Utilisez LinkedIn pour rechercher manuellement.",
    tavily_cleanup_title: "Imports web pollués détectés",
    tavily_cleanup_subtitle: "{{count}} entreprises importées via Tavily ressemblent à des articles ou répertoires, pas à de vraies entreprises. Examinées : {{examined}}.",
    tavily_cleanup_delete: "Supprimer ({{count}})",
    cleanup_confirm: "Supprimer définitivement {{count}} entrées polluées ? Cette action est irréversible.",
    cleanup_done: "{{count}} entrées polluées supprimées ✓",
  },
  api_credits: {
    title: "Crédits & quotas API",
    subtitle: "État des clés et crédits restants pour chaque service externe utilisé par l'application.",
    refresh: "Rafraîchir",
    summary_title: "{{ok}} / {{total}} services opérationnels",
    configured_count: "{{configured}} clés configurées sur {{total}}",
    checked_at: "Vérifié le {{time}}",
    not_configured: "Non configuré",
    ok: "OK",
    error: "Erreur",
    manage: "Gérer la clé",
    searches_month: "Recherches ce mois",
    verifications_month: "Vérifications ce mois",
    paid_credits: "Crédits payants",
    free_credits: "Crédits gratuits",
    reset_on: "Reset le {{date}}",
  },
  api_alerts: {
    view: "Voir",
    dismiss: "Masquer",
    more_count: "+{{count}} autre(s) alerte(s) sur d'autres services",
    toast_description: "Vérifiez les crédits API.",
    msg_warning_quota: "{{name}} : {{remaining}}/{{total}} requêtes restantes ce mois ({{pct}}%).",
    msg_warning_credits: "{{name}} : seulement {{remaining}} crédits restants.",
    msg_critical_quota: "{{name}} : critique — {{remaining}}/{{total}} requêtes ({{pct}}%).",
    msg_critical_credits: "{{name}} : critique — {{remaining}} crédits restants.",
    msg_over: "{{name}} : quota mensuel dépassé ({{total}} requêtes). Le service est bloqué jusqu'au reset.",
    msg_error: "{{name}} : erreur de service. {{error}}",
  },
};

export default fr;
